import { functions } from '@/config/firebase'
import { httpsCallable } from 'firebase/functions'

export const createPaymentPreference = async (bookingId: string, orgId: string) => {
    try {
        const createPayment = httpsCallable(functions, 'createMercadoPagoPayment')
        const result = await createPayment({ bookingId, orgId })
        const data = result.data as any

        if (data.success && data.preferenceId) {
            return {
                preferenceId: data.preferenceId,
                initPoint: data.initPoint
            }
        } else {
            throw new Error('Falha ao criar preferência de pagamento')
        }
    } catch (error) {
        console.error('Erro no paymentService:', error)
        throw error
    }
}

export const confirmPaymentMock = async (bookingId: string) => {
    // Mantendo mock de confirmação de pagamento manual por enquanto se necessário, 
    // mas a flow real é via webhook.
    console.warn('confirmPaymentMock chamado - isso deveria ser via webhook na produção')
}
